import { Col, Collapse, Flex, Form, Input, List, Row, Select, Spin, Tooltip } from "antd";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import {
  InnerTabs,
  MyBreadcrumb, MyButton,
  MyText,
  OuterTabs
} from "../../components";
import { CardItem } from "./index.styles";
import { ROUTE_PATH } from "../../constants";
import { createSearchParams, generatePath, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getJournalCurrentCtpListAction,
  getJournalCurrentCtpListActionDone,
  getJournalCurrentFilterAction,
  getJournalCurrentFilterActionDone,
  getJournalListAction, resetJournal,
} from "../../store/pages/journal/actions";
import { selectStore } from "../../store/selector";
import { RootState } from "../../store";
import { useTranslation } from "react-i18next";
import { setFormAction } from "../../store/common/actions";
import dayjs from "dayjs";
import _, { identity, pickBy } from "lodash";

interface LevelObject {
  name: string,
  value?: string,
  key?: string,
  url?: string,
  filter_url?: string,
}

let item = {
  name: '',
  value: '',
  key: '',
  url: '',
  filter_url: '',
}

const initialState = {
  1: item,
  2: item,
  3: item,
}

export const Journal = () => {
  const { t } = useTranslation("common")
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [adminForm] = Form.useForm()
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    profile: { userProfile },
    journal: { list: listState, listCurrent: listCurrentState, filter: filterState },
  }: RootState = useSelector(selectStore)

  const [tab, setTab] = useState<any>(initialState)

  useEffect(() => {
    if (userProfile.success) {
      dispatch(getJournalListAction())
    }
  }, [userProfile.success])


  useEffect(() => {
    if (listState.data) {
      let firstSearchParams = searchParams.get('first')
      let secondSearchParams = searchParams.get('second')
      let thirdSearchParams = searchParams.get('third')
      let first: any = listState.data?.find((item: any) => {
        return item.key == firstSearchParams || item.value == dayjs().year() || item.secondValue == dayjs().year()
      }) || listState.data?.[0]
      let second: any = first?.children?.find((item: any) => item.key == secondSearchParams) || first?.children?.[0]
      let third: any = second?.children?.find((item: any) => item.key == thirdSearchParams) || second?.children?.[0]

      setObjects(first, second, third)

      // @ts-ignore
      adminForm.setFieldsValue(Object.fromEntries([...searchParams]))
    }
  }, [listState.data]);

  const setUrlParams = (tabs: any, filterParams?: any) => {
    let body = {
      first: tabs[1]?.key,
      second: tabs[2]?.key,
      third: tabs[3]?.key,
      ...filterParams
    }

    setSearchParams(body)
  }

  const handleClickTab = (tabLevel: number, key: string) => {
    let firstItem: any
    let secondItem: any
    let thirdItem: any

    adminForm.resetFields()

    dispatch(getJournalCurrentCtpListActionDone(null))
    dispatch(getJournalCurrentFilterActionDone(null))

    switch (tabLevel) {
      case 1:
        firstItem = listState?.data?.find((item: any) => item.key == key)
        secondItem = firstItem?.children?.[0]
        thirdItem = secondItem?.children?.[0]
        setObjects(firstItem, secondItem, thirdItem)
        break
      case 2:
        firstItem = tab[1]
        secondItem = firstItem?.children?.find((item: any) => item.key == key)
        thirdItem = secondItem?.children?.[0]
        setObjects(firstItem, secondItem, thirdItem)
        break
      case 3:
        firstItem = tab[1]
        secondItem = tab[2]
        thirdItem = secondItem?.children?.find((item: any) => item.key == key)
        setObjects(firstItem, secondItem, thirdItem)
        break
      default:
        break
    }
  }

  const setObjects = (first: LevelObject, second: LevelObject, third: LevelObject) => {
    let body = {
      ...(first?.name ? { 1: first } : {}),
      ...(second?.name ? { 2: second } : {}),
      ...(third?.name ? { 3: third } : {}),
    }

    let totalUrlParams: any = Object.fromEntries(searchParams.entries())
    let { first: firstParams, second: secondParams, third: thirdParams, ...urlParams } = totalUrlParams

    setUrlParams(body, third?.filter_url ? urlParams : {})

    setTab((prevState: any) => ({
      ...prevState,
      ...body
    }))

    if (third?.filter_url) {
      let filterBody = {
        ...(first?.name ? { [first?.name]: first?.value } : {}),
        ...(second?.name ? { [second?.name]: second?.value } : {}),
        ...(third?.name ? { [third?.name]: third?.value } : {}),
      }

      dispatch(setFormAction({
        path: `edu/${third?.filter_url}`,
        method: 'get',
        fields: filterBody,
        action: getJournalCurrentFilterAction
      }))

      if (!_.isEmpty(urlParams)) {
        handleAdminFormSubmit(body, urlParams)
      }
    } else {
      getList(first, second, third)
    }
  }

  const getList = (first: LevelObject, second: LevelObject, third: LevelObject) => {
    let body = {
      [first?.name]: first?.value,
      [second?.name]: second?.value,
      [third?.name]: third?.value,
    }

    let url = third?.url ? `edu/${third?.url}` : 'edu/ctp'

    dispatch(getJournalCurrentCtpListAction({
      path: url,
      method: 'get',
      fields: body,
    }))
  }

  const handleClick = (item: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.JOURNAL_CURRENT, { id: item.id }),
      search: createSearchParams({
      }).toString()
    }

    dispatch(resetJournal())

    navigate(path);
  }

  const TabItem = memo(({ listItem }: any) => {
    return (
      <CardItem onClick={() => handleClick(listItem)}>
        <Row justify='space-between' gutter={[16, 16]} align='middle'>
          <Col span={6} style={{ borderRight: '1px solid var(--c-line)', height: '100%' }}>
            <MyText size={24} color='var(--c-title-text)'>
              {listItem.group}
            </MyText>
          </Col>

          <Col span={7}>
            <Row align='middle' gutter={[16, 2]}>
              <Col span={24}>
                <MyText size={16} color='var(--c-title-text)' weight={700}>
                  {listItem.module}
                </MyText>
              </Col>

              <Col span={24}>
                <MyText size={14} color='var(--c-subtitle)'>
                  {listItem.subject}
                </MyText>
              </Col>
            </Row>
          </Col>

          <Col span={4}>
            <Row align='middle' gutter={[16, 2]} justify='center'>
              {listItem?.teacher?.filter((item: any, index: any, self: any) => self.indexOf(item) === index)?.map((teacher: any) => (
                <Col span={24} key={teacher.id}>
                  <MyText size={14} color='var(--c-subtitle)'>
                    {teacher.fio}
                  </MyText>
                </Col>
              ))}
            </Row>
          </Col>

          {
            listItem?.right_to || listItem?.right_bottom && 
            <Col span={7}>
              <Row align='middle' gutter={[16, 2]}>
                {
                  listItem?.right_top && <Col span={24}>
                    <MyText size={16} color='var(--c-title-text)' weight={700}>
                      {listItem?.right_top}
                    </MyText>
                  </Col>
                }


                {
                  listItem?.right_bottom && <Col span={24}>
                    <MyText size={14} color='var(--c-subtitle)'>
                      {listItem?.right_bottom}
                    </MyText>
                  </Col>
                }
              </Row>
            </Col>
          }
          <Col span={7}>
            <Row align='middle' gutter={[16, 2]} justify='center'>
              {
                listItem.students?.length > 3 ? (
                  <Tooltip title={(
                    <Row>
                      {
                        listItem.students?.map((child: any) => (
                          <Col span={24} key={child}>
                            <MyText color='var(--c-icon)' size={14} style={{ display: 'block' }} align='right'>
                              {child}
                            </MyText>
                          </Col>
                        ))
                      }
                    </Row>
                  )}>
                    {
                      listItem.students?.slice(0, 3).map((child: any, childIndex: any) => (
                        <Col span={24} key={child}>
                          <MyText color='var(--c-icon)' size={14} style={{ display: 'block' }} align='right'>
                            {child} {childIndex === 2 ? '...' : ''}
                          </MyText>
                        </Col>
                      ))
                    }
                  </Tooltip>
                ) : (
                  listItem.students?.map((child: any) => (
                    <Col span={24} key={child}>
                      <MyText color='var(--c-icon)' size={14} style={{ display: 'block' }} align='right'>
                        {child}
                      </MyText>
                    </Col>
                  ))
                )
              }
            </Row>
          </Col>
        </Row>
      </CardItem>
    )
  })

  const handleAdminFormSubmit = (tabs: any, formValues: any) => {
    let currentFIlterValues = pickBy(formValues, identity)
    setUrlParams(tabs, currentFIlterValues)

    let body = {
      ...currentFIlterValues,
      [tabs[1]?.name]: tabs[1]?.value,
      [tabs[2]?.name]: tabs[2]?.value,
      [tabs[3]?.name]: tabs[3]?.value,
    }

    if (tabs[3]?.url) {
      dispatch(getJournalCurrentCtpListAction({
        path: `edu/${tabs[3]?.url}`,
        method: 'get',
        fields: body,
      }))
    }
  }

  const formRender = useCallback((children: React.ReactNode) => {
    return (
      <Spin spinning={filterState.loading}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form
              form={adminForm}
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
                flex: 1
              }}
              style={{ padding: 12 }}
              onFinish={(values: any) => handleAdminFormSubmit(tab, values)}
              onReset={() => handleAdminFormSubmit(tab, null)}
            >
              <Row gutter={8} align='bottom'>
                {
                  filterState.data?.fields?.map((field: any, fieldIndex: any) => (
                    <Col key={fieldIndex} span={24 / (filterState.data?.fields?.length + 1)} flex={1}>
                      <Form.Item label={field?.label} name={field?.name}>
                        <Select placeholder={field?.placeholder ? field?.placeholder : ''} disabled={field?.is_disabled}
                          showSearch filterOption={(input: any, option: any) => {
                            return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                          }}>
                          {field?.fieldValues?.map((fieldInner: any, index: any) => (
                            <Select.Option value={String(fieldInner.value)} key={"TYPE_SELECT" + index}>
                              {fieldInner.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  ))
                }
                <Col span={24 / (filterState.data?.fields?.length + 1)}>
                  <Row gutter={8} align='bottom'>
                    {
                      filterState.data?.fields?.length &&
                      <Col span={12}>
                        <MyButton title={t('set')} htmlType='submit' width='100%' height={40}
                          style={{ marginBottom: 12 }} />
                      </Col>
                    }

                    {
                      filterState.data?.fields?.length &&
                      <Col span={12}>
                        <MyButton title={t('reset')} htmlType='reset' width='100%' height={40}
                          style={{ marginBottom: 12 }} />
                      </Col>
                    }
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>

          <Col span={24}>
            {children}
          </Col>
        </Row>
      </Spin>
    )
  }, [filterState, tab])

  const innerTabContentItem = useMemo(() => {
    return (
      <List
        locale={{ emptyText: `${t('noRecords')}` }}
        dataSource={listCurrentState.data || []}
        loading={listCurrentState.loading}
        rowKey={(record: any) => `${record.id}-listState`}
        renderItem={(listItem: any) => (
          <Row>
            <Col span={24}>
              {
                listItem?.children?.length ?
                  <Collapse
                    style={{ margin: 10 }}
                    items={[{
                      key: 0,
                      label: (
                        <Row justify='space-between' align='middle'>
                          <Col span={10}>
                            <MyText size={24} color='var(--c-title-text)'>
                              {listItem.subject}
                            </MyText>
                          </Col>

                          <Col span={5}>
                            <Row align='middle' gutter={[16, 2]}>
                              {listItem?.teacher?.filter((item: any, index: any, self: any) => self.indexOf(item) === index)?.map((teacher: any) => (
                                <Col span={24} key={teacher.id}>
                                  <MyText size={14} color='var(--c-subtitle)'>
                                    {teacher.fio}
                                  </MyText>
                                </Col>
                              ))}
                            </Row>
                          </Col>

                          <Col span={3}>

                          </Col>
                        </Row>
                      ),
                      children: (
                        listItem?.children?.map((child: any, index: any) => (
                          <TabItem listItem={child} key={`${child.id}-${index}`} />
                        ))
                      )
                    }]}
                  />
                  : <TabItem listItem={listItem} />
              }
            </Col>
          </Row>
        )}
      />
    )
  }, [listCurrentState])

  const innerTabsRenderContent = useMemo(() => {
    if (tab[3]?.filter_url) {
      return formRender(innerTabContentItem)
    } else {
      return innerTabContentItem
    }
  }, [listCurrentState, filterState, tab])


  return (
    <>
      <MyBreadcrumb title={t('journal')} />

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <OuterTabs items={listState?.data?.map((first: any) => {
                return {
                  key: first?.key,
                  label: first?.label,
                  children: (
                    <InnerTabs items={first.children?.map((second: any) => ({
                      key: second?.key,
                      label: second?.label,
                      children: second.children ? (
                        <InnerTabs items={second.children?.map((third: any) => ({
                          key: third?.key,
                          label: third?.label,
                          children: innerTabsRenderContent,
                        }))} onTabClick={(key: any, e: any) => handleClickTab(3, key)} activeKey={tab[3]?.key} />
                      ) : innerTabsRenderContent,
                    }))} onTabClick={(key: any, e: any) => handleClickTab(2, key)} activeKey={tab[2]?.key} />
                  ),
                }
              })} onTabClick={(key: any, e: any) => handleClickTab(1, key)} activeKey={tab[1]?.key} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
